module.exports = __webpack_public_path__ + "img/MW_Telegram_Instruction_2.a9682c7a.gif";